import React from "react";

import "./index.scss";

const Button = ({ onClick, text, larger, darker }) => {
  const handleClick = (e) => {
    if (!onClick) return;

    e.preventDefault();
    onClick();
  };

  return (
    <button
      className={`button${larger ? " larger" : ""}${darker ? " darker" : ""}`}
      onClick={handleClick}
    >
      {text}
    </button>
  );
};

export default Button;
